module.exports = __webpack_public_path__ + "img/cloudy-snow.8200cc3.svg";